import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import moment from 'moment';
import 'moment-timezone';

import { DATE_TIME_FORMAT } from '../../constants';
import { createLineItem, findPurchase } from 'actions/purchases';
import { plansByMobileOperator } from 'helpers/listItemPlans';
import { transformErrorResponse } from 'helpers/errors';
import withPurchaseMethods from 'decorators/withPurchaseMethods';
import purchasePage from 'decorators/purchasePage';
import withCycles from 'decorators/withCycles';
import FormError from 'components/FormError';
import PurchaseItemList from 'components/PurchaseItemList/PurchaseItemList';
import AddLineItemsForm from 'components/AddLineItemsForm';
import { combinePurchaseWithSubs } from 'helpers/purchases';

class AddLineItems extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAttChosen: false,
      isSimoChosen: false,
      isQuickChosen: false,
      isAllChosen: false,
      error: null,
    };

    this.onSelectChange = this.onSelectChange.bind(this);
    this.createLineItem = this.createLineItem.bind(this);
  }

  onSelectChange({ target: { value } }) {
    this.setState({
      isAttChosen: plansByMobileOperator.att.includes(value),
      isSimoChosen: plansByMobileOperator.simo.includes(value),
      isQuickChosen: plansByMobileOperator.quick.includes(value),
      isAllChosen: plansByMobileOperator.all.includes(value),
      error: null,
    });
  }

  async createLineItem(attrs) {
    if (this.state.error) this.setState({ error: null });

    const {
      findPurchase,
      createLineItem,
      purchase: { id },
    } = this.props;

    let values = { ...attrs };
    if (values.item_type === 'mdn_change_fee' && !values.item_id) {
      values.item_id = '';
    }

    try {
      await createLineItem(id, values);
      await findPurchase(id);
    } catch (error) {
      this.setState({ error: transformErrorResponse(error.errors) });
    }
  }

  render() {
    const { purchase, subs, lineItems, lineItemsPage, itemType } = this.props;
    const { error } = this.state;

    if (!purchase) {
      return <div>Loading...</div>;
    }

    if (purchase && !['overdue', 'pending', 'open'].includes(purchase.status)) {
      return <Redirect to={`/purchases/${purchase.id}/view`} />;
    }

    const purchaseWithSubs = combinePurchaseWithSubs(purchase, lineItems, subs);

    return (
      <div>
        <h1>Add line items</h1>
        <p className="links">
          <Link className="mb-4" to={`/purchases/${purchase.id}/view`}>
            &larr; Back to Purchase
          </Link>
        </p>
        <div>
          <h3>Purchase {purchase.id}</h3>
          <h4>{purchase.shipping_full_name}</h4>
          <h6>
            {moment
              .tz(purchase.created_at, 'America/New_York')
              .format(DATE_TIME_FORMAT)}
          </h6>
        </div>
        <div>
          <PurchaseItemList
            items={purchaseWithSubs.line_items}
            purchase={purchase}
            lineItemsPage={lineItemsPage}
            pageBaseUrl={`/purchases/${purchase.id}/add-items`}
          />
        </div>
        <div>
          <AddLineItemsForm
            onSelectChange={this.onSelectChange}
            onSubmit={this.createLineItem}
            itemType={itemType}
            {...this.state}
          />
        </div>
        <div>{error && <FormError error={error} />}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const itemType = formValueSelector('addLineItems')(state, 'item_type');
  return {
    itemType,
  };
};

const mapDispatchToProps = {
  createLineItem,
  findPurchase,
};

export default compose(
  purchasePage,
  withPurchaseMethods,
  withCycles,
  connect(mapStateToProps, mapDispatchToProps),
)(AddLineItems);
